import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ALERT_TYPE } from 'src/app/constants';
import { Account } from 'src/model/account.model';
import { FundAllocation } from 'src/model/fundAllocation.model';

@Component({
    selector: 'app-fund-reallocation',
    templateUrl: './fund-reallocation.component.html',
    styleUrls: ['./fund-reallocation.component.scss'],
    standalone: false
})

export class FundReallocationComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns: string[];
  dataSource = new MatTableDataSource;

  accountList: Account[] = [];

  managerAccount: Account;
  loggedInUsername: string;
  totalAdjustment = 0;

  fundAllocationList: FundAllocation[] = [];
  date: Date;

  constructor() {
    // get cashAccounts
    this.getAllCashAccounts();
    this.loggedInUsername = sessionStorage.getItem("username");
  }

  ngOnInit(): void {
    this.displayedColumns = ['Name', 'Current', 'Allocation', 'Adjustment'];
  }

  checkIsOwnAccount(username: string) {
    const loggedInUsername = sessionStorage.getItem["username"];
    if (username == loggedInUsername)
      return true;
    else
      return false;
  }

  calculateAdjustment(account: Account) {
    account.Adjustment = account.Allocation - account.Balance;
    return account.Adjustment;
  }

  getTotalAdjustment() {
    this.totalAdjustment = this.accountList.map(t => t.Adjustment).reduce((acc, value) => acc + value, 0);

    return this.totalAdjustment;
  }

  getAllCashAccounts() {
    const xhttp = this.restapi.getRequest(this.constructApi.getAllAccounts())
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        // Typical action to be performed when the document is ready:

        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.accountNumber, json.name, json.holderName, json.balance, json.companyId, json.username, json.balance)

          //if username undefined = cash account
          //because only manager can come into this function, so just check the loggedInUsername to identify manager
          if (account.Username != undefined) {
            if (account.Username != this.loggedInUsername)
              //add account instance into account list
              this.accountList.push(account);
            else
              this.managerAccount = account;
          }
        });

        //make account list as the datasource
        this.dataSource = new MatTableDataSource<Account>(this.accountList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    };
    // xhttp.open("GET", url, true);
    // xhttp.send();
  }

  calculateManagerAdjustment(managerAccount: Account) {
    this.managerAccount.Adjustment = (managerAccount.Balance - this.totalAdjustment) - managerAccount.Balance;
    return this.managerAccount.Adjustment;
  }

  createFundAllocationJSON() {
    for (let i = 0; i < this.accountList.length; i++) {
      const fund = new FundAllocation(this.accountList[i].Username, this.accountList[i].Adjustment);
      this.fundAllocationList.push(fund);
    }

    const managerFund = new FundAllocation(this.managerAccount.Username, this.managerAccount.Adjustment);
    this.fundAllocationList.push(managerFund);

    return this.fundAllocationList
  }

  postFundAllocation() {
    if (this.date == undefined)
      this.sharedService.openAlert("Please select Reallocation date!", ALERT_TYPE.DANGER);
    else {
      const data = {
        "date": this.date.toISOString(),
        "accounts": this.createFundAllocationJSON()
      }

      const xhr = this.restapi.postRequest(this.constructApi.getPostFundAllocation(), data)
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4 && xhr.status == 200) {
          this.reset();

          this.sharedService.openAlert("Successfully reallocate fund!", ALERT_TYPE.SUCCESS);
        }
      }
    }
  }

  reset() {
    this.activeModal.close();
  }
}
